import React from 'react';
import Form from 'react-bootstrap/Form';
import { useForceUpdate } from '../util';
import { FormValidityProvider } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
export default function TaskMusicPlayer(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Raw ABC String: ")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 10,
    value: dataProps.notation,
    onChange: e => {
      if (e.target.value === "") {
        dataProps.notation = undefined;
      } else {
        dataProps.notation = e.target.value;
      }
      forceUpdate();
      props.onChanged();
    }
  })))));
}